import React from 'react';
import PropTypes from 'prop-types';
import ScoreCard from './ScoreCard';
import StatList from './StatList';
import Commentary from './Commentary';
import DeceptionSuspectList from './DeceptionSuspectList';
import summaryContentType from '../proptypes/summary-content';
import {
  statsInterrogationType,
  observationResultsType,
  statsTellType,
} from '../proptypes/deception';
import { DataDescription } from './Typography';
import ScoreCardSection from './ScoreCardSection';

const ScoreCardDeception = ({
  gameTitle,
  imageUrl,
  videoUrl,
  gameKey,
  summary,
  latestRound,
  statsInterrogation,
  observationResults,
  statsTell,
  socialCommentary,
}) => (
  <ScoreCard
    {...{
      gameTitle,
      imageUrl,
      videoUrl,
      gameKey,
      summary,
    }}
  >
    <ScoreCardSection>
      <DataDescription large>{latestRound}</DataDescription>
    </ScoreCardSection>
    <ScoreCardSection>
      <StatList {...statsInterrogation} />
    </ScoreCardSection>
    <ScoreCardSection>
      <DataDescription large>Lie detection Skills</DataDescription>
      <DeceptionSuspectList {...observationResults} />
    </ScoreCardSection>
    <ScoreCardSection>
      <StatList {...statsTell} />
    </ScoreCardSection>
    <Commentary phrase={socialCommentary} />
  </ScoreCard>
);

ScoreCardDeception.propTypes = {
  gameTitle: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  gameKey: PropTypes.string.isRequired,
  latestRound: PropTypes.string.isRequired,
  socialCommentary: PropTypes.string.isRequired,
  summary: summaryContentType.isRequired,
  statsInterrogation: statsInterrogationType.isRequired,
  observationResults: observationResultsType.isRequired,
  statsTell: statsTellType.isRequired,
};

export default ScoreCardDeception;
